import { ESCAPE, hasModifierKey } from '@angular/cdk/keycodes';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ConfirmActionDialogComponent } from 'app/main/components/confirm-action-dialog/confirm-action-dialog.component';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

/** "Descartar alterações?" com Continuar editando (ghost) e Descartar (danger). Emite true ao descartar. */
export function confirmDiscard(dialog: MatDialog): Observable<boolean> {
    return dialog.open(ConfirmActionDialogComponent, {
        panelClass: ['form-dialog'],
        data: {
            title: 'Descartar alterações?',
            message: 'Os dados preenchidos serão perdidos.',
            yesText: 'Descartar',
            noText: 'Continuar editando',
            confirmVariant: 'danger',
        },
    }).afterClosed().pipe(map((confirmed) => confirmed === true));
}

/**
 * Diálogo de formulário que fecha pelo ×, Esc e toque fora, mas pede confirmação
 * quando `isDirty()` (sem alterações, fecha direto). Enquanto `isBusy()` (salvando), não fecha.
 * Retorna a função de fechar, para o × e o botão Cancelar/Descartar.
 */
export function guardDialogClose(
    dialogRef: MatDialogRef<any>,
    dialog: MatDialog,
    isDirty: () => boolean,
    isBusy: () => boolean = () => false,
): () => void {
    let confirming = false;
    dialogRef.disableClose = true;

    const requestClose = () => {
        if (isBusy()) {
            return;
        }
        if (!isDirty()) {
            dialogRef.close();
            return;
        }
        if (confirming) {
            return;
        }
        confirming = true;
        confirmDiscard(dialog).subscribe((discard) => {
            confirming = false;
            if (discard) {
                dialogRef.close();
            }
        });
    };

    dialogRef.backdropClick().subscribe(() => requestClose());
    dialogRef.keydownEvents()
        .pipe(filter((event) => event.keyCode === ESCAPE && !hasModifierKey(event)))
        .subscribe((event) => {
            event.preventDefault();
            requestClose();
        });

    return requestClose;
}
